
import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "providers/ThemeProvider";
import { Container, Card } from "components/common";
import axios from "axios";
import { Wrapper, Grid, Item, Content, Stats } from "./styles";
import nitt from "../../../assets/illustrations/nitt.png";
import stmarys from "../../../assets/illustrations/logo.png";
import jaiacademy from "../../../assets/illustrations/logo1.webp";
import { HoverableCard } from 'react-hoverable-card'
import 'react-hoverable-card/dist/index.css'
import styled from 'styled-components';
import ScrollAnimation from 'react-animate-on-scroll';
import "animate.css/animate.min.css";

export const Education = () => {
  const { theme } = useContext(ThemeContext);
  const [college, setCollege] = useState([]);
  useEffect(() => {
    const colleges = [
      {
        name: "NIT Trichy",
        id: 1,
        svn_url: " https://www.nitt.edu/",
        description: "B.Tech, Mechanical Engineering(2019-2023)",
        grade: "9.07 CGPA",
        img: nitt
      },
      {
        name: "Jai Academy",
        id: 2,
        svn_url: "https://www.jaiacademy.in/",
        description: "Completed my Inter college with PCM+CS in CBSE board.",
        grade: "91.6%",
        img: jaiacademy
      },
      {
        name: "St. Mary's School, English Medium",
        id: 3,
        svn_url: "http://www.stmaryemmauranipur.com/",
        description: "Completed my high school with CBSE board.",
        grade: "10.0 CGPA",
        img: stmarys
      }
    ];
    setCollege(colleges);
  }, []);

  const BigTitle = styled.a({
    textTransform: "uppercase",
    textDecoration: "none",
    fontSize: "1rem",
    color: `${theme === "light" ? "#000" : "#fff"} !important`,
  });
  const Heading = styled.h1({
    fontSize: "3rem",
    color: `rgb(228 93 93) !important`,
    '@media(max-width: 700px)': {
      fontSize: '1.5rem'
    }
  });

  return (
    <Wrapper as={Container} id="education">
      {<Heading>Education</Heading>}
      <Grid theme={theme}>
        {college.map((node) => (
          <ScrollAnimation animateIn="animate__zoomIn" duration="3" >
            <div key={node.id}>
              <HoverableCard
                cardTitle={node.grade}
                cardDescription={`${node.description} 
          Grade: ${node.grade}`}
                cardImage={node.img}
                hoverBgColor="grey"
              />
              <BigTitle
                theme={theme} href={node.svn_url}>{node.name}</BigTitle>
            </div></ScrollAnimation>
        ))}
      </Grid>
    </Wrapper>
  );
};
